import { CONFIG } from "./config.ts";

export interface Stage {
  index: number;
  name: string;
  /** Visual scale multiplier applied to the player's base radius. */
  scale: number;
  /** Primary body color. */
  color: string;
  /** Secondary / shading color. */
  shade: string;
  /** Short flavor line shown on evolve. */
  blurb: string;
}

// The Enlightenment Ladder. Index 0 = single cell, last = Buddha (win).
export const STAGES: readonly Stage[] = [
  { index: 0, name: "Single Cell", scale: 1.0, color: "#8fe3c2", shade: "#57b892", blurb: "A speck with ambitions." },
  { index: 1, name: "Amoeba", scale: 1.25, color: "#7fd8e0", shade: "#4aa7b3", blurb: "Now with a nucleus." },
  { index: 2, name: "Worm", scale: 1.5, color: "#f0a5a5", shade: "#cf6d6d", blurb: "Squirming upward." },
  { index: 3, name: "Fly", scale: 1.7, color: "#9aa0b5", shade: "#5c6178", blurb: "Drawn to fresh poop." },
  { index: 4, name: "Frog", scale: 2.0, color: "#9ede7a", shade: "#5fa63f", blurb: "Hop toward the light." },
  { index: 5, name: "Cat", scale: 2.35, color: "#f2c98a", shade: "#c99a52", blurb: "Smugly ascending." },
  { index: 6, name: "Dog", scale: 2.75, color: "#e6b98f", shade: "#b78a5f", blurb: "Good boy. Great karma." },
  { index: 7, name: "Monkey", scale: 3.2, color: "#c79a72", shade: "#946b46", blurb: "Mischief before enlightenment." },
  { index: 8, name: "Human", scale: 3.7, color: "#f0c3a0", shade: "#c1906a", blurb: "Upright, at last." },
  { index: 9, name: "Monk", scale: 4.3, color: "#e79a5c", shade: "#b96f36", blurb: "Serene. Almost there." },
  { index: 10, name: "Buddha", scale: 5.2, color: "#ffd769", shade: "#e0a52b", blurb: "Enlightenment. You now poop gold." },
] as const;

export const FINAL_STAGE = STAGES.length - 1;

/** XP required to advance out of a given stage. */
export function xpToNext(stage: number): number {
  const { base, growth } = CONFIG.progression;
  return Math.round(base * Math.pow(growth, stage));
}

export const stageAt = (i: number): Stage => STAGES[Math.min(i, FINAL_STAGE)];
